// extracted by mini-css-extract-plugin
export default {"flex":"drug_admin_table_flex__kuFbM"};